import React from 'react';

export default function AtlasToolbar({ overview, zoom, onOverview, onZoom }: {
  overview: boolean; zoom: number; onOverview: (value: boolean) => void; onZoom: (value: number) => void;
}) {
  return <div className="lite-map-tools" aria-label="Map view controls">
    <button aria-pressed={overview} onClick={() => onOverview(!overview)}>{overview ? 'Follow me' : 'Whole venue'}</button>
    <button aria-label="Zoom out" disabled={zoom <= .75} onClick={() => onZoom(Math.max(.75, zoom - .25))}>−</button>
    <span>{Math.round(zoom * 100)}%</span>
    <button aria-label="Zoom in" disabled={zoom >= 2} onClick={() => onZoom(Math.min(2, zoom + .25))}>+</button>
  </div>;
}
